export const DEFAULT_LABELS = {
	title: ' Find Your Favorites Onsite!',
	description:
		'Your favorite products from Beacon Discovery are now on the Expo West show floor map too.',
	button_text: 'Go to the map'
};
export const DEFAULT_LINKS = {
	link: 'https://www.expowest.com/en/About/2026-floor-plan.html'
};
